import Image from "next/image";
import { TKey } from "@/app/translations/TKey";
import { useT } from "@/app/translations/useT";
import { HOW_FILE_CUSTOMER } from "../../HowItWorks/HowItWorks.logic";
import { FOR_WHO_AVATAR_SIZE } from "../ForWho.logic";
import styles from "../ForWho.module.css";

export default function ForWhoQuote() {
  const T = useT();

  return (
    <figure className={styles.quote}>
      <figcaption className={styles.quoteHead}>
        <Image
          className={styles.avatar}
          src={HOW_FILE_CUSTOMER.photo}
          alt=""
          width={FOR_WHO_AVATAR_SIZE}
          height={FOR_WHO_AVATAR_SIZE}
          unoptimized
        />
        <span className={styles.author}>
          <span className={styles.authorName}>{HOW_FILE_CUSTOMER.name}</span>
          <span className={styles.authorMeta}>
            {`${T(TKey.HOME_MEIDLY_HOW_EX_BUDGET)} · ${HOW_FILE_CUSTOMER.company}`}
          </span>
        </span>
        <span className={styles.tag}>{T(TKey.EXCHANGE_TAG_OBJECTION)}</span>
      </figcaption>
      <blockquote className={styles.quoteText}>{T(TKey.HOME_WHO_QUOTE)}</blockquote>
    </figure>
  );
}
